import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Grid2 as Grid,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const AnalyticCards = ({ cardData, showCardActions }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 450);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 450);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigate = useNavigate();

  const carouselSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const renderCard = (data, index) => (
    <Card
      variant="outlined"
      sx={{
        width: 275,
        backgroundColor: `analyticCards.${(index % 4) + 1}`,
        borderRadius: 3,
        cursor: "pointer",
      }}
      onClick={() => navigate(data?.route)}
    >
      <CardContent sx={{ padding: "16px !important" }}>
        <Typography
          gutterBottom
          sx={{ color: "text.dark", fontSize: 18, fontWeight: "bolder" }}
        >
          {data?.title}
        </Typography>
        <Typography
          gutterBottom
          sx={{
            color: "text.dark",
            fontSize: 25,
            fontWeight: "bold",
          }}
        >
          {data?.value}
        </Typography>
        {/* <Typography
          gutterBottom={showCardActions ? true : false}
          sx={{ color: "text.dark", fontSize: 14, fontWeight: "bold" }}
        >
          {data?.subTitle}
        </Typography> */}
      </CardContent>
      {/* {showCardActions && (
        <CardActions>
          <Button onClick={() => data?.action()} size="small">
            <Typography
              sx={{
                color: "text.dark",
                fontSize: 16,
                fontWeight: "bold",
              }}
            >
              {data?.actionName}
            </Typography>
          </Button>
        </CardActions>
      )} */}
    </Card>
  );

  return isMobile ? (
    <Box
      style={{
        width: 300,
        margin: "auto",
      }}
      className="slider-container"
    >
      <Slider {...carouselSettings}>
        {cardData.map((data, index) => renderCard(data, index))}
      </Slider>
    </Box>
  ) : (
    <Stack justifyContent="center">
      <Grid container size={12} spacing={2}>
        {cardData.map((data, index) => renderCard(data, index))}
      </Grid>
    </Stack>
  );
};

export default AnalyticCards;
